import script from "./AlarmHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmHeader.vue?vue&type=script&setup=true&lang=js"

import "./AlarmHeader.vue?vue&type=style&index=0&id=9dc3dd22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dc3dd22"]])

export default __exports__